import React, { useCallback, useEffect, useMemo, useState } from "react";
import Input from "../../../../components/Common/Input/Input";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { detailsSchema } from "../../../../utils/mainTabs/manage/createShotclassSchema";
import { useDispatch, useSelector } from "react-redux";
import {
  copyShotclassActionHandler,
  createShotclassActionHandler,
  getSearchClassTagsActionHandler,
  isNameExistsActionHandler,
  updateShotclassActionHandler,
} from "../../../../store/actions/actionHandlers/manageActionHandler";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import Button from "../../../../components/Common/Button/Button";
import AddContent from "../../../../containers/manage/CreateShotClass/AddContent/AddContent";
import SelectThumbnail from "../../../../containers/manage/CreateShotClass/SelectThumbnail/SelectThumbnail";
import classes from "./Details.module.scss";
import Modal from "../../../../components/Common/Modal/Modal";
import ViewContent from "../../../../containers/manage/CreateShotClass/ViewContent/ViewContent";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../utils/errorTypes";
import loaders from "../../../../store/actions/actionCreators/loadersActionCreator";
import {
  moderateContributionDetailsSchema,
  submisssions,
} from "../../../../utils/mainTabs/social/submissions";
import { setShotClassFormData } from "../../../../store/actions/actionCreators/socialActionCreator";
import AddTrainingTypeModal from "../../../../components/Manage/AddTrainingTypeModal/AddTrainingTypeModal";
import { FormattedMessage, useIntl, injectIntl } from "react-intl";
import { moderateContributions } from "../../../../utils/mainTabs/social/moderateContributions";
// import { usePrompt } from "../../../../hooks/preventNavigationHook";
const Details = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const {
    formValues,
    setFormValues,
    allLanguageVariant,
    trainingTypes,
    setTrainingTypes,
    shotclassType,
    shotclassTypeFrom,
    manageTiles,
    setManageTiles,
    managePath,
    createShotclassesPath,
    tenantName,
    initialFormState,
    MSOMFeaturesInShotclass,
    isWebinarSelected,
    setIsWebinarSelected,
  } = useOutletContext();

  const manageState = useSelector((state) => state.manageReducer);
  const {
    getClassDetailsById,
    isShotclassNameExistLoader,
    getLanguagesLoader,
    getTrainingTypesLoader,
    getShotclassTagLoader,
    saveAsADraftLoader,
  } = manageState;

  const socialState = useSelector((state) => state.socialReducer);
  const { shotClassFormData } = socialState;

  //1-main form, 2-content upload, 3-thumbnail upload
  const [activeSection, setActiveSection] = useState(1);
  const [formData, setFormData] = useState([]);
  const [existsShotClassName, setExistsShotClassName] = useState(null);
  const [validShotClassName, setValidShotClassName] = useState(true);
  const [validTagSearch, setValidTagSearch] = useState(true);
  const [viewContentModal, setViewContentModal] = useState(false);
  const [isContentUpdated, setIsContentUpdated] = useState(false);
  // const [tagsList, setTagsList]= useState([]);
  const [searchTagsList, setSearchTagsList] = useState([]);
  const [searchTrainingTypeList, setSearchTrainingTypeList] = useState([]);
  const [isAddTrainingTypeModal, setIsAddTrainingTypeModal] = useState(false);
  const [normalExit, setNormalExit] = useState(false);
  const [calanderName, setCalanderName] = useState("");

  let buttonTexts = useMemo(() => {
    return {
      addQuiz: "Add Quiz",
      addSurvey: "Add Survey",
      publish: "Publish",
    };
  }, []);
  const [submitButtonText, setSubmitButtonText] = useState(buttonTexts.addQuiz);

  const methods = useForm({
    resolver: yupResolver(
      location.pathname ===
        `${submisssions.shotClassespath(params, location, tenantName)}/details`
        ? moderateContributionDetailsSchema
        : detailsSchema
    ),
    mode: "onChange",
    defaultValues: useMemo(() => {
      return {
        ...formValues.details,
        isContentRequired: false,
        YouTubeSearch1: "",
        YouTubeSearch2: "",
        OnlineSearch: "",
        SlideShareSearch: "",
      };
    }, [formValues.details]),
  });

  const {
    handleSubmit,
    formState: { errors, isDirty, isValid },
    reset,
    setValue,
    watch,
    getValues,
    trigger,
  } = methods;
  const ShotClassName = watch("ShotClassName");
  const TrainingType = watch("TrainingType");
  const TagsList = watch("TagsList");
  const Description = watch("Description");
  const Summary = watch("Summary");
  const thumbnailName = watch("ThumbnailImage");
  const CalendarUrl = watch("CalendarUrl");

  // Add this helper function at the top of your Details component (after imports)
  const isDistributedQuizSurveyOnlyClass = (formValues) => {
    // debugger;
    // Check if class is distributed
    const isDistributed = formValues?.Other?.IsDistributed;

    if (!isDistributed) {
      return false;
    }

    // Check if there's quiz content
    const hasQuizContent =
      formValues?.addQuiz?.TotalQuestionCount > 0 ||
      formValues?.addQuiz?.QuestionsList?.some((q) => q.Question?.trim());

    // Check if there's survey content
    const hasSurveyContent =
      formValues?.addSurvey?.TotalQuestionCount > 0 ||
      formValues?.addSurvey?.QuestionsList?.some((q) => q.Question?.trim());

    // Check if there's NO main learning content
    const hasNoMainContent =
      !formValues?.details?.Content?.ContentValue &&
      !formValues?.Other?.VideoUrl &&
      (!formValues?.Other?.Mediatype || formValues?.Other?.Mediatype > 0) &&
      (!formValues?.details?.Content?.ContentMediaType ||
        formValues?.details?.Content?.ContentMediaType > 0);

    // Return true if distributed AND has quiz/survey AND no main content
    return (
      isDistributed && (hasQuizContent || hasSurveyContent) && hasNoMainContent
    );
  };

  // Add this useEffect to track webinar selection (add after your existing useEffects)
  useEffect(() => {
    // Track webinar selection state
    if (TrainingType && TrainingType.length > 0) {
      const isWebinar = TrainingType.some(
        (type) =>
          (typeof type === "object" &&
            type?.Name?.toLowerCase() === "webinar") ||
          (typeof type === "string" && type.toLowerCase() === "webinar")
      );
      const wasWebinar = isWebinarSelected;
      const isNowWebinar = isWebinar;

      // Check restrictions for distributed classes
      const isDistributed = formValues?.Other?.IsDistributed;
      const isEditMode = shotclassType === "edit";
      const isCopyMode = shotclassType === "copy";

      // Restriction 1: Prevent any training type change for distributed webinar classes
      if (isDistributed && isEditMode && wasWebinar && !isNowWebinar) {
        // Revert the change - webinar distributed classes cannot change training type
        setValue(
          "TrainingType",
          TrainingType.filter((type) => type?.Name?.toLowerCase() === "webinar")
        );

        dispatch(
          setErrorHandler(
            errorTypes.WARN,
            "Training type cannot be changed for distributed webinar classes."
          )
        );
        return;
      }
// debugger;
      // Restriction 2: Prevent webinar selection for distributed non-webinar classes
      if ((isDistributed && isEditMode && !wasWebinar && isNowWebinar) || (isDistributedQuizSurveyOnlyClass(formValues) && isCopyMode && !wasWebinar && isNowWebinar)) {
        // Revert the selection - distributed classes cannot select webinar
        setValue("TrainingType", []);
        setIsWebinarSelected(false);
        setValue("isWebinarSelected", false);

        dispatch(
          setErrorHandler(
            errorTypes.WARN,
            "Webinar training type is not available for distributed classes."
          )
        );
        return;
      }

      // Existing content validation logic for non-distributed classes or create mode
      if (!isDistributed || shotclassType !== "edit") {
        if (!wasWebinar && isNowWebinar) {
          const currentContent = getValues("Content.ContentValue");
          const currentMediaType = getValues("Content.ContentMediaType");
          let currentExtension = getValues("Content.ContentMediaExtension");
          // if (shotclassType === "edit" || shotclassType === "copy") {
          //   const cleanUrl = currentContent?.split("?")?.[0];
          //   const parts = cleanUrl?.split("/");
          //   const filename = parts?.[parts.length - 1];
          //   const extension = filename?.includes(".")
          //     ? filename?.split(".").pop()
          //     : "";
          //   currentExtension = extension;
          // }
          if (shotclassType === "edit" || shotclassType === "copy") {
            // Fix: Add proper type checking before calling split()
            if (currentContent && typeof currentContent === "string") {
              const cleanUrl = currentContent.split("?")[0];
              const parts = cleanUrl?.split("/");
              const filename = parts?.[parts.length - 1];
              const extension = filename?.includes(".")
                ? filename?.split(".").pop()
                : "";
              currentExtension = extension;
            } else if (
              Array.isArray(currentContent) &&
              currentContent.length > 0
            ) {
              // Handle array of content (multiple files)
              const firstContent = currentContent[0];
              if (typeof firstContent === "string") {
                const cleanUrl = firstContent.split("?")[0];
                const parts = cleanUrl?.split("/");
                const filename = parts?.[parts.length - 1];
                const extension = filename?.includes(".")
                  ? filename?.split(".").pop()
                  : "";
                currentExtension = extension;
              } else if (firstContent && firstContent.name) {
                // Handle file object
                const filename = firstContent.name;
                const extension = filename?.includes(".")
                  ? filename?.split(".").pop()
                  : "";
                currentExtension = extension;
              }
            }
          }

          const isCurrentContentInvalid =
            currentContent &&
            currentContent.length > 0 &&
            ([5, 8, 9, 11].includes(currentMediaType) ||
              (currentExtension &&
                ["mp3", "m4a"].includes(currentExtension.toLowerCase())));
          // debugger;
          if (isCurrentContentInvalid) {
            setValue("Content.ContentValue", "");
            setValue("Content.ContentMediaType", 0);
            setValue("Content.ContentMediaExtension", "");

            dispatch(
              setErrorHandler(
                errorTypes.WARN,
                "For a Webinar type please upload – Video (AVI, MP4, MPG, MOV), YouTube, or Documents (PPT, PPTX, PDF)"
              )
            );
          }
        }
      }

      // Update the webinar state only if selection is valid
      if (
        !isDistributed ||
        shotclassType !== "edit" ||
        (isDistributed && isEditMode && wasWebinar === isNowWebinar)
      ) {
        setIsWebinarSelected(isNowWebinar);
        setValue("isWebinarSelected", isNowWebinar);
      }

      trigger(["Content.ContentValue", "CalendarUrl"]);
    } else {
      // Only reset if not a distributed webinar class in edit mode
      const isDistributed = formValues?.Other?.IsDistributed;
      const isEditMode = shotclassType === "edit";

      if (!(isDistributed && isEditMode && isWebinarSelected)) {
        setIsWebinarSelected(false);
        setValue("isWebinarSelected", false);
      }
    }
  }, [
    TrainingType,
    trigger,
    setValue,
    formValues?.Other?.IsDistributed,
    shotclassType,
    isWebinarSelected,
    dispatch,
    getValues,
  ]);
  useEffect(() => {
    setCalanderName(CalendarUrl);
    dispatch(
      setShotClassFormData({
        ...shotClassFormData,
        details: {
          ...formValues?.details,
          ShotClassName: ShotClassName,
          TrainingType: TrainingType,
          TagsList: TagsList,
          Description: Description,
          Summary: Summary,
          ThumbnailImage: thumbnailName,
          CalendarUrl: CalendarUrl,
        },
      })
    );
  }, [
    dispatch,
    ShotClassName,
    TrainingType,
    TagsList,
    Summary,
    Description,
    thumbnailName,
    isWebinarSelected, // Add this dependency
  ]);

  useEffect(() => {
    if (formValues?.ShotclassId && formValues?.Other?.VideoUrl) {
      reset(() => {
        return { ...formValues?.details, isContentRequired: true };
      });
    } else {
      reset(() => formValues?.details);
    }
  }, [
    formValues?.ShotclassId,
    formValues?.details,
    formValues?.Other?.VideoUrl,
    reset,
  ]);

  useEffect(() => {
    if (shotclassType === "copy") {
      dispatch(
        isNameExistsActionHandler(
          getClassDetailsById?.Name + "_Copy",
          setExistsShotClassName
        )
      );
    }
  }, [dispatch, shotclassType, getClassDetailsById?.Name]);

  useEffect(() => {
    if (trainingTypes?.length > 0) {
      const updatedTrainingTypes = trainingTypes?.map((trainingType) => {
        return { ...trainingType, isVisible: true };
      });
      setSearchTrainingTypeList(updatedTrainingTypes);
    }
  }, [trainingTypes]);

  const handleViewContentModal = useCallback(() => {
    if (
      formValues?.Other?.Mediatype === 8 ||
      formValues?.Other?.Mediatype === 9 ||
      formValues?.Other?.Mediatype === 11
    ) {
      window.open(formValues?.Other?.VideoUrl);
    } else {
      setViewContentModal(!viewContentModal);
    }
  }, [viewContentModal, formValues?.Other]);

  const handleNameExists = useCallback(
    (e) => {
      let val = e.target.value.trim() !== "" && e.target.value.trim();
      if (val) {
        if (/^[a-zA-Z0-9:_@?#|'`\]\[ ]*$/.test(val)) {
          setValidShotClassName(true);
          const encodedVal = encodeURIComponent(val);
          dispatch(
            isNameExistsActionHandler(encodedVal, setExistsShotClassName)
          );
        } else {
          setValidShotClassName(false);
        }
      } else {
        setValidShotClassName(true);
        setExistsShotClassName(false);
      }
    },
    [dispatch, setExistsShotClassName, setValidShotClassName]
  );

  const handleSearchTags = useCallback(
    (e) => {
      let val = e.target.value.trim() !== "" && e.target.value;
      if (val) {
        if (/^[A-Za-z0-9@# ]+$/.test(val)) {
          setValidTagSearch(true);
          dispatch(
            getSearchClassTagsActionHandler(e.target.value, setSearchTagsList)
          );
        } else {
          setValidTagSearch(false);
        }
      } else {
        setValidTagSearch(true);
        setSearchTagsList([]);
      }
    },
    [dispatch, setValidTagSearch]
  );

  const handleSearchTrainingType = useCallback(
    (e) => {
      let val = e.target.value.trim() !== "" && e.target.value;
      if (val) {
        const filteredTrainingTypes = trainingTypes?.filter((trainingType) =>
          trainingType.Name?.toLowerCase().includes(val?.toLowerCase())
        );
        setSearchTrainingTypeList(filteredTrainingTypes);
      } else {
        setSearchTrainingTypeList(trainingTypes);
      }
    },
    [trainingTypes]
  );

  const handleAddTrainingType = useCallback(() => {
    setIsAddTrainingTypeModal(!isAddTrainingTypeModal);
  }, [isAddTrainingTypeModal]);

  const handleSelectContent = useCallback(
    (text) => {
      if (text) {
        setSubmitButtonText(text);
      }
      setActiveSection(1);
      trigger(["Content.ContentValue"]);
    },
    [trigger]
  );
  useEffect(() => {
    if (formValues?.Other?.IsDistributed) {
      if (formValues?.Other?.ShotClassType === 1) {
        setSubmitButtonText(buttonTexts.publish);
      } else if (
        formValues?.Other?.ShotClassType === 2 ||
        formValues?.Other?.ShotClassType === 3 ||
        formValues?.Other?.ShotClassType === 5 ||
        formValues?.Other?.ShotClassType === 6
      ) {
        setSubmitButtonText(buttonTexts.addQuiz);
      } else if (
        formValues?.Other?.ShotClassType === 4 ||
        formValues?.Other?.ShotClassType === 7
      ) {
        setSubmitButtonText(buttonTexts.addSurvey);
      }
      // if (formValues?.addQuiz?.TotalQuestionCount > 0) {
      //   setSubmitButtonText(buttonTexts.addQuiz);
      // } else if (
      //   formValues?.addQuiz?.TotalQuestionCount === 0 &&
      //   formValues?.addSurvey?.TotalQuestionCount > 0
      // ) {
      //   setSubmitButtonText(buttonTexts.addSurvey);
      // } else if (
      //   formValues?.addQuiz?.TotalQuestionCount === 0 &&
      //   formValues?.addSurvey?.TotalQuestionCount === 0
      // ) {
      //   setSubmitButtonText(buttonTexts.publish);
      // }
    } else {
      if (formValues?.details?.Content?.ContentMediaType === 8) {
        setSubmitButtonText(buttonTexts.publish);
      } else {
        setSubmitButtonText(buttonTexts.addQuiz);
      }
    }
  }, [
    buttonTexts,
    formValues?.details?.Content?.ContentMediaType,
    formValues?.Other?.IsDistributed,
    formValues?.addQuiz?.TotalQuestionCount,
    formValues?.addSurvey?.TotalQuestionCount,
    formValues?.Other?.ShotClassType,
    formValues?.details?.TrainingType,
  ]);

  const handleSelectContentType = (name, val) => {
    setValue(name, val);
    setIsContentUpdated(() => true);
  };

  const handleActiveSection = (section) => {
    setActiveSection(section);
    trigger(["ThumbnailImage"]);
  };

  const handleCancelImage = useCallback(() => {
    trigger(["ThumbnailImage"]);
  }, [trigger]);

  const handleCancelFileContent = useCallback(() => {
    // Reset ContentMediaType to initial value (0) when content is removed
    setValue("Content.ContentMediaType", 0);

    // Reset ContentValue as well
    setValue("Content.ContentValue", "");
    trigger(["Content.ContentValue"]);

    if (
      !formValues?.Other?.IsDistributed &&
      formValues?.Other?.Mediatype !== 8
    ) {
      handleSelectContent(buttonTexts.addQuiz);
    }

    if (!formValues?.Other?.IsDistributed) {
      let updatedTiles = manageTiles?.map((tile) => {
        if (
          (tile.path === `${createShotclassesPath}/addQuiz` ||
            tile.path ===
              `${submisssions.shotClassespath(
                params,
                location,
                tenantName
              )}/addQuiz`) &&
          formValues?.addQuiz?.TotalQuestionCount > 0
        ) {
          // Show Quiz tile when content is removed, but hide if webinar is selected
          return {
            ...tile,
            hidden: isWebinarSelected,
            isCompleted: true,
          };
        } else if (
          (tile.path === `${createShotclassesPath}/addSurvey` ||
            tile.path ===
              `${submisssions.shotClassespath(
                params,
                location,
                tenantName
              )}/addSurvey`) &&
          formValues?.addSurvey?.TotalQuestionCount > 0
        ) {
          // Show Survey tile when content is removed, but hide if webinar is selected
          return {
            ...tile,
            hidden: isWebinarSelected,
            isCompleted: true,
          };
        } else if (
          tile.path === `${createShotclassesPath}/addQuiz` ||
          tile.path ===
            `${submisssions.shotClassespath(
              params,
              location,
              tenantName
            )}/addQuiz`
        ) {
          // Show Quiz tile by default when content is removed, but hide if webinar is selected
          return {
            ...tile,
            hidden: isWebinarSelected,
            isCompleted: false,
          };
        } else if (
          tile.path === `${createShotclassesPath}/addSurvey` ||
          tile.path ===
            `${submisssions.shotClassespath(
              params,
              location,
              tenantName
            )}/addSurvey`
        ) {
          // Show Survey tile by default when content is removed, but hide if webinar is selected
          return {
            ...tile,
            hidden: isWebinarSelected,
            isCompleted: false,
          };
        } else {
          return tile;
        }
      });
      setManageTiles(updatedTiles);
    }
  }, [
    trigger,
    buttonTexts.addQuiz,
    formValues?.Other?.IsDistributed,
    formValues?.Other?.Mediatype,
    handleSelectContent,
    createShotclassesPath,
    formValues?.addQuiz?.TotalQuestionCount,
    formValues?.addSurvey?.TotalQuestionCount,
    // location,
    manageTiles,
    // navigate,
    // params,
    setManageTiles,
    isWebinarSelected,
    // tenantName,
  ]);

  const handleDownloadVideo = useCallback(() => {
    window.open(formValues?.Other?.VideoUrl);
  }, [formValues?.Other?.VideoUrl]);

  //Validating ics file upload
  const handleIcsFileUpload = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      const fileName = file.name.toLowerCase();
      if (!fileName.endsWith(".ics")) {
        dispatch(
          setErrorHandler(errorTypes.WARN, "Please upload a valid .ics file.")
        );
        // Optionally clear the input if needed
        // e.target.value = "";
        setValue("CalendarUrl", null); // Reset the ics field
        return;
      }
      // Proceed with your file handling logic here
      // Example: setValue("ics", file);
      console.log("Setting valid ICS file:", file);
      setValue("CalendarUrl", [file]); // Set the file as array to match expected format
      trigger(["CalendarUrl"]); // Trigger validation
    }
  };

  const handleCancelIcsFileContent = () => {
    // debugger
    setCalanderName("");
    setValue("CalendarUrl", null); // Reset the ics field
    trigger(["CalendarUrl"]);
  };

  useEffect(() => {
    // if (trainingTypes?.length > 0) {
    manageTiles?.forEach((tile) => {
      if (location.pathname === tile.path) {
        let contentValue = formValues?.details?.Content?.ContentValue;
        let isDistributed = formValues?.Other?.IsDistributed;
        let contentUpdated =
          isContentUpdated || contentValue !== formValues?.Other?.VideoUrl;
        let isVideoDownload =
          (shotclassType === "edit" ||
            shotclassType === "copy" ||
            shotclassType === "view") &&
          !contentUpdated &&
          formValues?.Other?.Mediatype === 1 &&
          shotclassTypeFrom === "myDrafts";

        // Determine if this is a distributed webinar class being edited
        const isDistributedWebinarClass =
          isDistributed && isWebinarSelected && shotclassType === "edit";

        // Determine if this is a distributed non-webinar class being edited
        const isDistributedNonWebinarClass =
          isDistributed && !isWebinarSelected && shotclassType === "edit";

        let formArgs = {
          allLanguageVariant,
          searchTrainingTypeList,
          shotclassType,
          contentValue,
          isDistributed,
          contentUpdated,
          isVideoDownload,
          handleDownloadVideo,
          handleNameExists,
          handleSearchTags,
          // handleSearchTrainingType,
          setSearchTrainingTypeList,
          handleAddTrainingType,
          searchTagsList,
          validTagSearch,
          setActiveSection,
          handleViewContentModal,
          handleCancelFileContent,
          handleCancelImage,
          isShotclassNameExistLoader,
          getLanguagesLoader,
          getTrainingTypesLoader,
          getShotclassTagLoader,
          handleIcsFileUpload, //ics file upload validation method
          handleCancelIcsFileContent, // ics file cancel button click method
          isWebinarSelected, // Add this new state to formArgs

          // Add these new flags for training type restrictions
          isDistributedWebinarClass, // Flag for distributed webinar classes
          isDistributedNonWebinarClass, // Flag for distributed non-webinar classes
          disableTrainingTypeForDistributedWebinar: isDistributedWebinarClass, // Completely disable for webinar
          filterWebinarForDistributedNonWebinar: isDistributedNonWebinarClass, // Filter webinar only
        };
        let data = tile.formData(formArgs);

        if (!MSOMFeaturesInShotclass.courseLanguage) {
          const updatedData = data?.filter(
            (field) => field.name !== "Language"
          );
          setFormData(updatedData);
        } else {
          // According to Training type hide or show upload ics field
          if (
            TrainingType[0]?.Name?.toLowerCase() === "webinar" ||
            isWebinarSelected
          ) {
            setFormData(data);
          } else {
            setFormData(
              data?.filter(
                (field) => field.name.toLowerCase() !== "calendarurl"
              )
            );
          }
        }
      }
    });
    // }
  }, [
    location,
    shotclassType,
    manageTiles,
    isContentUpdated,
    allLanguageVariant,
    handleNameExists,
    handleSearchTags,
    // trainingTypes,
    // handleSearchTrainingType,
    setSearchTrainingTypeList,
    handleAddTrainingType,
    validTagSearch,
    formValues?.Other?.Mediatype,
    shotclassTypeFrom,
    searchTagsList,
    searchTrainingTypeList,
    handleDownloadVideo,
    handleViewContentModal,
    handleCancelFileContent,
    handleCancelImage,
    formValues.details.Content?.ContentMediaExtension,
    formValues?.details?.Content?.ContentValue,
    formValues?.Other?.IsDistributed,
    formValues?.Other?.VideoUrl,
    isShotclassNameExistLoader,
    getLanguagesLoader,
    getTrainingTypesLoader,
    getShotclassTagLoader,
    // handleIcsFileUpload,
    // handleCancelIcsFileContent
    TrainingType,
    isWebinarSelected,
  ]);

  const handleClearAll = () => {
    reset(() => initialFormState.details);
    setFormValues((formValues) => {
      return {
        ...formValues,
        details: initialFormState.details,
      };
    });
    setValidShotClassName(true);
    setExistsShotClassName(false);
  };

  const onSubmit = (data) => {
    // const selectedTrainingTypes = data?.TrainingType?.map(
    //   (training) => training.TypeId
    // );
    let updatedTiles = manageTiles.map((tile) => {
      if (
        tile.path === `${createShotclassesPath}/details` ||
        tile.path ===
          `${submisssions.shotClassespath(
            params,
            location,
            tenantName
          )}/details`
      ) {
        return { ...tile, isCompleted: true };
      } else {
        return tile;
      }
    });
    setFormValues((formValues) => {
      return {
        ...formValues,
        details: {
          ...formValues.details,
          ...data,
          isWebinarSelected: isWebinarSelected, // trainingtype is webinar
          // TrainingType: selectedTrainingTypes,
        },
        disableTabsOnValid:
          formValues?.addQuiz?.TotalQuestionCount == 0 ? false : true,
      };
    });
    if (
      location.pathname ===
      `${submisssions.shotClassespath(params, location, tenantName)}/details`
    ) {
      dispatch(
        setShotClassFormData({
          ...formValues,
          details: { ...formValues.details, ...data },
        })
      );
    }
    setManageTiles(() => updatedTiles);
    if (isWebinarSelected) {
      // If webinar is selected, skip quiz/survey and go directly to publish
      navigate(`${createShotclassesPath}/publishShotclass`);
    } else if (submitButtonText === buttonTexts.publish) {
      navigate(`${createShotclassesPath}/publishShotclass`);
    } else if (submitButtonText === buttonTexts.addQuiz) {
      if (
        location?.pathname?.includes(
          `${submisssions.viewPath(tenantName)}/${params?.shotclassId}`
        ) ||
        location?.pathname?.includes(
          `${submisssions.updatePath(tenantName)}/${params?.shotclassId}`
        )
      )
        navigate(
          `${submisssions.shotClassespath(
            params,
            location,
            tenantName
          )}/addQuiz`
        );
      else navigate(`${createShotclassesPath}/addQuiz`);
    } else if (submitButtonText === buttonTexts.addSurvey) {
      navigate(`${createShotclassesPath}/addSurvey`);
    }
    // if (data?.Content?.ContentMediaType === 8) {
    //   navigate(`${createShotclassesPath}/publishShotclass`);
    // }
  };

  const handleSaveAsDraft = () => {
    dispatch(loaders.manage.createShotclasses.saveAsADraftLoader(true));

    const detailsData = getValues();

    let shotclassData = {
      ...formValues,
      details: { ...detailsData },
    };

    if (shotclassType === "edit") {
      dispatch(updateShotclassActionHandler(shotclassData, "Saved"))
        .then((isSaved) => {
          if (isSaved) {
            if (isSaved !== "video") {
              dispatch(
                setErrorHandler(
                  errorTypes.SUCCESS,
                  `Your Shotclass ${shotclassData?.details?.ShotClassName} is saved successfully`
                )
              );
            }
            dispatch(
              loaders.manage.createShotclasses.saveAsADraftLoader(false)
            );
            navigate(managePath);
          }
        })
        .finally(() => {
          dispatch(loaders.manage.createShotclasses.saveAsADraftLoader(false));
        });
    } else if (shotclassType === "copy") {
      dispatch(copyShotclassActionHandler(shotclassData, "Saved"))
        .then((isSaved) => {
          if (isSaved) {
            if (isSaved !== "video") {
              dispatch(
                setErrorHandler(
                  errorTypes.SUCCESS,
                  `Your Shotclass ${shotclassData?.details?.ShotClassName} is saved successfully
            `
                )
              );
            }
            dispatch(
              loaders.manage.createShotclasses.saveAsADraftLoader(false)
            );
            navigate(managePath);
          }
        })
        .finally(() => {
          dispatch(loaders.manage.createShotclasses.saveAsADraftLoader(false));
        });
    } else {
      dispatch(
        createShotclassActionHandler(
          shotclassData,
          "Saved",
          "LearningContentWithQuizAndSurvey"
        )
      )
        .then((isSaved) => {
          if (isSaved) {
            if (isSaved !== "video") {
              dispatch(
                setErrorHandler(
                  errorTypes.SUCCESS,
                  `Your Shotclass ${shotclassData?.details?.ShotClassName} is saved successfully
            `
                )
              );
            }
            dispatch(
              loaders.manage.createShotclasses.saveAsADraftLoader(false)
            );
            navigate(managePath);
          }
        })
        .finally(() => {
          dispatch(loaders.manage.createShotclasses.saveAsADraftLoader(false));
        });
    }
  };
  // console.log(formData)
  // useEffect(() => {
  //   if (isDirty) setNormalExit(true);
  // }, [setNormalExit, isDirty]);
  // usePrompt("Are you sure you want to leave this page?", normalExit);
  return (
    <>
      <FormProvider {...methods}>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className={classes.details__form}
        >
          {activeSection === 1 ? (
            <div className={classes.details__form__inputFields}>
              {formData.map((field) => {
                let fieldNameArr = field?.name.split(".");
                let fieldErrors =
                  fieldNameArr.length > 1
                    ? errors?.[fieldNameArr[0]]?.[fieldNameArr[1]]?.message
                    : errors?.[fieldNameArr[0]]?.message;
                let placeholder = field?.placeholder;
                let label = field?.label;
                return (
                  <div
                    key={field?.key}
                    className={classes.details__form__inputFields__field}
                  >
                    <Input
                      label={field?.label}
                      labelMsg={field?.labelMsg}
                      name={field?.name}
                      placeholder={field?.placeholder}
                      // placeholder={intl.formatMessage({
                      //   id: `${placeholder}`,
                      // })}
                      buttonLabel={field?.buttonLabel}
                      subButtonLabel={field?.subButtonLabel}
                      subButtonIcon={field?.subButtonIcon}
                      handleSubButton={field?.handleSubButton}
                      fieldName={field?.fieldName}
                      disableLabelClick={field?.disableLabelClick}
                      disabled={shotclassType === "view" || field?.disabled}
                      fieldValue={field?.fieldValue}
                      type={field?.type}
                      width={field?.width}
                      height={field?.height}
                      maxLength={field?.maxLength}
                      labelColor={field?.labelColor}
                      tagType={field?.tagType}
                      searchTagsList={field?.searchTagsList}
                      isValidTagSearch={field?.isValidTagSearch}
                      valueArr={field?.valueArr}
                      error={field?.name !== "ShotClassName" && fieldErrors}
                      defaultValue={field?.defaultValue}
                      required={field?.required}
                      hidden={field?.hidden}
                      onChange={field?.onChange}
                      handleTagList={field?.handleTagList}
                      addedTagsVisible={field?.addedTagsVisible}
                      isTagCheckBoxVisible={field?.isTagCheckBoxVisible}
                      searchable={field?.searchable}
                      handleClickFileButton={field?.handleClickFileButton}
                      fileInputName={
                        field?.name === "ThumbnailImage"
                          ? thumbnailName?.FileName
                          : field?.name === "CalendarUrl" &&
                            // Show "File" if it's edit/copy/view mode and there's existing file data (not array)
                            !Array.isArray(calanderName) &&
                            calanderName &&
                            calanderName !== "" &&
                            (shotclassType === "edit" ||
                              shotclassType === "copy" ||
                              shotclassType === "view")
                          ? "File"
                          : ""
                      }
                      fileInputView={field?.fileInputView}
                      handleFileInputView={field?.handleFileInputView}
                      fileInputDownload={field?.fileInputDownload}
                      handleFileInputDownload={field?.handleFileInputDownload}
                      handleCancelFileInput={field?.handleCancelFileInput}
                      loading={field?.loading}
                      accept={field?.accept}
                    />
                    {field?.name === "ShotClassName" ? (
                      errors?.[field?.name]?.message ? (
                        <div
                          className={
                            classes.details__form__inputFields__field__error
                          }
                        >
                          {errors?.[field?.name]?.message}
                        </div>
                      ) : !validShotClassName ? (
                        <div
                          className={
                            classes.details__form__inputFields__field__error
                          }
                        >
                          Only alphanumeric and special characters like
                          ':#@?[]_`| are allowed
                        </div>
                      ) : !isShotclassNameExistLoader && existsShotClassName ? (
                        <div
                          className={
                            classes.details__form__inputFields__field__error
                          }
                        >
                          Sorry,Name already exists
                        </div>
                      ) : (
                        <></>
                      )
                    ) : (
                      <></>
                    )}
                    {field?.name === "TagsList" && !validTagSearch && (
                      <div
                        className={
                          classes.details__form__inputFields__field__error
                        }
                      >
                        Only alphanumeric and special characters like @# are
                        allowed
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ) : activeSection === 2 ? (
            <AddContent
              handleSelectContent={handleSelectContent}
              buttonTexts={buttonTexts}
              setValue={handleSelectContentType}
              manageTiles={manageTiles}
              setManageTiles={setManageTiles}
              contentMediaType={formValues?.Other?.Mediatype}
              contentValue={formValues?.details?.Content?.ContentValue}
              shotclassType={shotclassType}
              createShotclassesPath={createShotclassesPath}
              isDistributed={formValues?.Other?.IsDistributed}
              quizQuestionCount={formValues?.addQuiz?.TotalQuestionCount}
              surveyQuestionCount={formValues?.addSurvey?.TotalQuestionCount}
              isSlideShareFeaturePresent={MSOMFeaturesInShotclass?.slideShare}
              isWebinarSelected={isWebinarSelected}
            />
          ) : activeSection === 3 ? (
            <SelectThumbnail setActiveSection={handleActiveSection} />
          ) : (
            <></>
          )}
          <div
            className={classes.details__form__footer}
            style={{
              justifyContent:
                activeSection === 3 ? "space-between" : "flex-end",
            }}
          >
            {activeSection === 1 && (
              <>
                {shotclassType === "create" && (
                  <div
                    className={classes.details__form__footer__clearAll}
                    onClick={() => handleClearAll()}
                  >
                    <FormattedMessage id="CLEAR_ALL_TXT" />
                  </div>
                )}
                {shotclassType !== "view" &&
                  (shotclassType !== "edit" ||
                    (shotclassType === "edit" &&
                      shotclassTypeFrom === "myDrafts")) &&
                  !location.pathname.includes(
                    moderateContributions.path(tenantName)
                  ) && (
                    <Button
                      label={
                        saveAsADraftLoader ? (
                          "Saving..."
                        ) : (
                          <FormattedMessage id="SAVE_CLASS_TEXT" />
                        )
                      }
                      disabled={
                        !isValid || existsShotClassName || !validShotClassName
                      }
                      small
                      dark
                      onClick={() => {
                        handleSaveAsDraft();
                        //setNormalExit(false);
                      }}
                      loading={saveAsADraftLoader}
                    />
                  )}
                <Button
                  // label={submitButtonText}
                  label="Next"
                  small
                  dark
                  type="submit"
                  disabled={
                    !isValid || existsShotClassName || !validShotClassName
                  }
                  // onClick={() => setNormalExit(false)}
                />
              </>
            )}
          </div>
        </form>
        <Modal
          isOpen={viewContentModal}
          toggle={() => handleViewContentModal()}
          width={"90"}
          height={"45"}
        >
          <ViewContent
            viewContent={viewContentModal}
            shotclassData={formValues?.Other}
          />
        </Modal>
      </FormProvider>
      <AddTrainingTypeModal
        handleAddTrainingTypeModal={handleAddTrainingType}
        isAddTrainingTypeModal={isAddTrainingTypeModal}
        setTrainingTypes={setTrainingTypes}
        setValue={setValue}
      />
    </>
  );
};

export default Details;
